import { render, staticRenderFns } from "./FormulaCanvas.vue?vue&type=template&id=66f74c52&scoped=true"
import script from "./FormulaCanvas.vue?vue&type=script&lang=js"
export * from "./FormulaCanvas.vue?vue&type=script&lang=js"
import style0 from "./FormulaCanvas.vue?vue&type=style&index=0&id=66f74c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f74c52",
  null
  
)

export default component.exports